import template from './index.html'
import {getScreenWidth, getScreenHeight} from '../../helpers'

const pageCamera = () => {

  let _C = [], N = 0;

  const NF = 30,
    TFN = {
      'linear': function (k) { return k },
      'ease-in': function (k, e = 1.675) {
        return Math.pow(k, e)
      },
      'ease-out': function (k, e = 1.675) {
        return 1 - Math.pow(1 - k, e)
      },
      'ease-in-out': function (k) {
        return .5 * (Math.sin((k - .5) * Math.PI) + 1)
      },
      'bounce-out': function (k, a = 2.75, b = 1.5) {
        return 1 - Math.pow(1 - k, a) * Math.abs(Math.cos(Math.pow(k, b) * (n + .5) * Math.PI))
      }
    };

  let i = 0, x0 = null, locked = false, w, ini, fin, rID = null, anf, n;

  return {
    root: null,
    monitorBody: '',
    players: [],
    isHD: false,
    title: '',
    showControls: true,
    onSlide: 1,
    device: null,
    currentSlide: 0,
    isPlaying: false,
    playAudio: false,
    selectedPlayer: null,
    async init() {
      this.root = this
      this.device = this.app.context.device
      this.title = this.device.cameras[this.app.context.cameraIndex].name
      this.currentSlide = this.app.context.cameraIndex
      i = this.currentSlide
      this.selectedPlayer = i
      const self = this
      Array.from(Array(this.device.cameras.length).keys()).forEach(i => {
        this.players.push(this.app.components.player({
          id: i,
          //attrClass: 'border border-red-500',
          attrClass: 'bg-black',
          //marginTop: this.app.safeTop/2/* + 48*/,
          //marginTop: this.app.safeArea.top,
          //marginTop: 48,
          //width: this.app.orientation == 'portrait' ? window.screen.width : window.screen.height,
          //height: this.app.orientation == 'portrait' ? window.screen.height/3 : window.screen.width,
          camera: this.device.cameras[i],
          device: this.app.context.device,
          path: this.app.context.path,
          onClick() {
            if (this.onSlide == 1) return
            let index = 0
            for (let i=0; i < self.players.length; i++) {
              if (self.players[i].id == this.id) {
                index = i
                break
              }
            }
            if (self.selectedPlayer == index) return
            if (self.selectedPlayer != null && self.playAudio) {
                self.players[self.selectedPlayer].playAudio(false)
                self.playAudio = false
            }
            self.players[self.selectedPlayer].select(0)
            this.select(1)
            self.selectedPlayer = index
          },
          onDblClick() {
            console.log('onDblClick')
            console.log(this)
          }
        }))
      })

      N = Math.ceil(this.device.cameras.length / this.onSlide)

      this.callIOS('setScrollParams', { params: [['top',56]] })
      this.callIOS('setCamGridParams', { params: [['rotate', 0], ['marginLeft',0], ['width', 32 * window.innerHeight], ['height', 'auto']] })

      this.app.on('orientation', this.changeOrientation, this)

      this.$nextTick(_ => {
        this.$el.innerHTML = template
        this.$nextTick(_ => {
          _C = document.querySelector('.cam-grid')
          this.changeOrientation(this.app.orientation)
        })
      })
    },
    makeSlides() {
      this.size()
      const screenWidth = getScreenWidth()
      const screenHeight = getScreenHeight()

      this.players.forEach(async player => {
        const slide = Math.floor(player.id / this.onSlide)
        const num = player.id - Math.floor(player.id / this.onSlide) * this.onSlide
        let ww = 0
        let hh = 0
        switch (this.onSlide) {
          case 1:
            ww = screenWidth
            hh = this.app.orientation == 'portrait' ? 300 : screenHeight
            await player.setTop(0)
            await player.setLeft(screenWidth * slide + num * ww)
            await player.setWidth(ww)
            await player.setHeight(hh)
            break
          case 4:
            ww = screenWidth / 2
            hh = this.app.orientation == 'portrait' ? 150 : screenHeight / 2
            if (num >= 2) {
              await player.setTop(hh)
              await player.setLeft(screenWidth * slide + (num - 2) * ww)
            } else {
              await player.setTop(0)
              await player.setLeft(screenWidth * slide + num * ww)
            }
            await player.setWidth(ww)
            await player.setHeight(hh)
            break
          case 9:
            ww = screenWidth / 3
            hh = 100
            if (num >= 6) {
              await player.setTop(hh * 2)
              await player.setLeft(screenWidth * slide + (num - 6) * ww)
            } else if (num >= 3) {
              await player.setTop(hh)
              await player.setLeft(screenWidth * slide + (num - 3) * ww)
            } else {
              await player.setTop(0)
              await player.setLeft(screenWidth * slide + num * ww)
            }
            await player.setWidth(ww)
            await player.setHeight(hh)
            break
        }
      })

      _C.style.setProperty('--n', N)
      _C.style.setProperty('--i', i);
      window._app.callIOS('setScrollOffset', i * w)
    },
    async changeOrientation(orientation) {
      if (orientation == 'portrait') {
        //await this.callIOS('setSafeParams', { params: [['marginTop', '1px'], ['width', '1px'], ['height', 48]] })
      } else {
        //await this.callIOS('setSafeParams', { params: [['marginTop', 0], ['width', 0], ['height', 0]] })
      }
      //await this.players[0].setWidth(orientation == 'portrait' ? window.screen.width : window.screen.height)
      //await this.players[0].setHeight(orientation == 'portrait' ? window.screen.height / 3 : window.screen.width)
      this.makeSlides()
    },
    getSlidePlayers() {
      let players = []
      const start = this.currentSlide * this.onSlide
      for (let i = start; i < start + this.onSlide; i++) {
        if (i >= this.device.cameras.length) break
        players.push(i)
      }
      return players
    },
    play() {
      this.isPlaying = true
      this.getSlidePlayers().forEach(i => {
        this.players[i].play()
      })
    },
    stop() {
      this.isPlaying = false
      this.players.forEach(player => {
        player.stop()
      })
    },
    hd() {
      this.isPlaying = true
      this.isHD = !this.isHD
      this.getSlidePlayers().forEach(async i => {
        this.players[i].play()
      })
    },
    deactivating() {
      console.log('deactivating camera')
      this.stop()
    },
    deactivated() {
      console.log('deactivated camera')
      this.players.forEach(player => {
        player.nativeHide()
      })
    },
    navigatingTo() {
      console.log('navigatingTo camera')
    },
    activating() {
      console.log('activating camera')
      window._app.callIOS('setScrollOffset', i * w)
      this.players.forEach(player => {
        player.nativeShow()
      })
      this.play()
    },
    navigatedTo() {
      console.log('navigatedTo camera')
      this.root.app.pages.forEach(page => {
        if (page.context.id != 'camera') page.context.class = 'hidden'
      })
      this.players.forEach(player => {
        player.attrClass = ''
      })
    },
    navigatingFrom() {
      console.log('navigatingFrom camera')
      this.root.app.pages.forEach(page => {
        if (page.context.id != 'camera') page.context.class = ''
      })
      this.root.app.off('orientation', this.changeOrientation)
    },
    navigatedFrom() {
      console.log('navigatedFrom camera')
      this.players = []
      console.log('camera closed')
    },
    back() {
      this.app.goBack()
    },
    toggleControls() {
      this.showControls = !this.showControls
    },
    channelOnSlide(num) {
      this.onSlide = num
      this.currentSlide = 0
      N = Math.ceil(this.device.cameras.length / this.onSlide)
      i = 0
      _C.style.setProperty('--n', N)
      _C.style.setProperty('--i', 0)
      window._app.callIOS('setScrollOffset', 0)
      this.makeSlides()
      this.toSlide(this.currentSlide)
    },
    toSlide(n) {
      this.isPlaying = false
      this.players.forEach(player => {
        player.stop()
      })
      this.currentSlide = n
      this.playAudio = false
      this.app.context.cameraIndex = this.currentSlide
      if (this.onSlide == 1) {
        this.title = this.device.cameras[n].name
      } else {
        const players = this.getSlidePlayers()
        this.title = 'Камеры ' + (players[0]+1) + '-' + (players.pop()+1)
      }

      if (this.selectedPlayer != null) this.players[this.selectedPlayer].select(0)
        if (this.onSlide > 1) {
          this.selectedPlayer = this.currentSlide*this.onSlide
          this.players[this.selectedPlayer].select(1)
        }

      this.play()
    },
    toggleAudio() {
      this.playAudio = !this.playAudio
      this.players[this.selectedPlayer].playAudio(this.playAudio)
    },
    stopAni() {
      if (this.currentSlide != i) this.toSlide(i)
      cancelAnimationFrame(rID);
      rID = null
    },
    ani(cf = 0) {
      if (anf == 0) return
      const i = anf > 0 ? ini + (fin - ini) * TFN['ease-out'](cf / anf) : 0
      window._app.callIOS('setScrollOffset', i * w)

      _C.style.setProperty('--i', i);

      if (cf === anf) {
        this.stopAni()
        return
      }

      cf += 1
      rID = requestAnimationFrame(this.ani.bind(this, cf))
    },
    unify(e) { return e.changedTouches ? e.changedTouches[0] : e },
    size() { w = this.app.orientation == 'portrait' ? window.screen.width : window.screen.height },
    lock(e) {
      x0 = this.unify(e).clientX;
      locked = true
    },
    drag(e) {
      e.preventDefault()

      if (locked) {
        let dx = this.unify(e).clientX - x0
        let f = +(dx / w).toFixed(2)
        let ii = i - f
        if (ii < 0) {
          ii = 0
          locked = false
        }
        if (ii > N - 1) {
          ii = N - 1
          locked = false
        }
        window._app.callIOS('setScrollOffset', ii * w)
        _C.style.setProperty('--i', ii)
      }
    },
    move(e) {
      if (locked) {
        console.log(i)
        let dx = this.unify(e).clientX - x0
        let s = Math.sign(dx)
        let f = +(s * dx / w).toFixed(2)

        ini = i - s * f

        if ((i > 0 || s < 0) && (i < N - 1 || s > 0) && f > .2) {
          i -= s;
          f = 1 - f
        }

        fin = i;
        anf = Math.round(f * NF)
        n = 2 + Math.round(f)
        this.ani()
        x0 = null
        locked = false
      }
    }
  }
}

export { pageCamera }
